import Repository from '@/repositories/repository'

const CompanyAboutUsRepository = {
  async getCompanyAboutUs(queryParams: any = {}) {
    const params = {
      ...queryParams
    }

    return await Repository('about-us', 'page', params)
  }
}

export default CompanyAboutUsRepository
